import React, { Component, Fragment } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import { EardrumMaterial } from '../infrastructure/AppConstants';
import Select from 'react-select';
import { BaseTextBox } from '../controls/BaseTextBox';
import Toast from '../controls/BaseToast';
import { CheckIcon, BanIcon } from '@heroicons/react/solid';

export default class EardrumMaterialColorViewDialog extends Component {
    constructor(props) {
        super(props);
        this.state = { earmoldCategories:[], eardrumMaterialOptions: [{ "label": <FormattedMessage id="HardEardrumMaterial" />, value: EardrumMaterial.Hard }, { "label": <FormattedMessage id="SoftEardrumMaterial" />, value: EardrumMaterial.Soft }], color: "", id: "", eardrumMaterialSelected:[],errMessage:''}
        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.bindProductOption = this.bindProductOption.bind(this);
        this.handlEarmoldCategoryCheck = this.handlEarmoldCategoryCheck.bind(this);
    }

    handlEarmoldCategoryCheck(e) {
        let target = e.target;
        let id = target.id;
        let items = this.state.earmoldCategories;
        for (let i = 0; i < items.length; i++) {
            if (id === items[i].id) {
                items[i].checked = !items[i].checked;
                break;
            }
        }
        this.setState({ earmoldCategories: items });
    }

    componentDidMount() {
        this.props.onRef(this);
        this.setState({ eardrumMaterialSelected: this.state.eardrumMaterialOptions[0] });
    }

    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

    }

    async populateEarmoldCategoryListData(op) {
        const token = await authService.getAccessToken();
        let id = op === null ? '' : op.id;
        const response = await fetch('ProductOption/GetEarmoldCategoriesForEarmoldMaterialColor?id=' + id, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        let result = await response.json();

        this.setState({ earmoldCategories: result });
    }

    async bindProductOption(productOption) {
        if (productOption) {
            this.setState({
                color: productOption.color, eardrumMaterialSelected: this.state.eardrumMaterialOptions.filter(x => x.value == productOption.eardrumMaterial)[0], id: productOption.id
            });
        }
        
        this.populateEarmoldCategoryListData(productOption)
    }
    onClose() {
        this.props.onClose();
        this.clearForm();
    }
    clearForm() {
        this.setState({ eardrumMaterial: "", color: "", id: "", errMessage:''});
    }
    async handleOnSubmit(e) {
        e.preventDefault();
        var eardrumMaterial = this.state.eardrumMaterialSelected.value;
        var color = this.state.color;
        var id = this.state.id;
        if (!color) {
            this.setState({ errMessage: 'Required' });
            return;
        }

        var earmoldCategoryIds = new Array();
        var earmoldCategories = this.state.earmoldCategories;
        for (var i = 0; i < earmoldCategories.length; i++) {
            if (earmoldCategories[i].checked) {
                earmoldCategoryIds.push(earmoldCategories[i].id);
            }
        }        

        let response = null;
        const token = await authService.getAccessToken();
        if (id) {
            response = await fetch('ProductOption/EditEardrumMaterialColorOption', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'id': id,
                    'eardrumMaterial': eardrumMaterial,
                    'color': color,
                    'earmoldCategoryIds': earmoldCategoryIds
                })
            })
        } else {
            response = await fetch('ProductOption/CreateEardrumMaterialColorOption', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'eardrumMaterial': eardrumMaterial,
                    'color': color,
                    'earmoldCategoryIds': earmoldCategoryIds
                })
            })
        }
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    this.onClose();
                    this.props.populateListData();
                }
                else {
                    Toast.warn(data.message);

                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }

    }
    onSelectChange = selectedOption => {
        this.setState({
            eardrumMaterialSelected: selectedOption
        })
    };
    render() {
        const customStyles = {
            control: (base, state) => ({
                ...base,
                "*": {
                    boxShadow: "none !important",
                },
            }),
        }
        const open = this.props.open;
        return (
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={this.onClose}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
          </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <form onSubmit={this.handleOnSubmit} style={{ width: '100vw' }}>
                                <div className="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                        <div className="">
                                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900"><FormattedMessage id="EardrumMaterialColor" /></Dialog.Title>
                                               
                                                <div className="mt-2">
                                                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Material" /></label>
                                                    <Select onChange={this.onSelectChange} className="inline-block min-w-0 w-full"
                                                        closeMenuOnSelect={true}
                                                        styles={customStyles}
                                                        value={this.state.eardrumMaterialSelected}
                                                        options={this.state.eardrumMaterialOptions}
                                                        placeholder=""
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Color" /></label>
                                                    <BaseTextBox classnames="min-w-0 w-3/4 mt-2" type="text" name="color" errmessage={this.state.errMessage} placeholder="" value={this.state.color} onChange={this.onChange} />
                                                </div>
                                                <div className="mt-2">
                                                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EardrumVersion" /></label>
                                                    <div className="grid grid-cols-3 gap-2">
                                                        {this.state.earmoldCategories.map(c =>
                                                            <div onClick={this.handlEarmoldCategoryCheck} id={c.id} key={c.id} className={c.checked ? "mt-3 w-full inline-flex justify-center rounded-md border border-indigo-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                                                : "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"}>
                                                                <label>{c.name}</label>
                                                                <span className="pointer-events-none flex items-center pl-3">
                                                                    {
                                                                        c.checked ? <CheckIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" /> :
                                                                            <BanIcon className="h-5 w-5 text-red-500 group-hover:text-red-400" aria-hidden="true" />}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                            onClick={this.onClose}><FormattedMessage id="Cancel" /></button>
                                        <button type="submit"
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"><FormattedMessage id="Submit" /></button>

                                    </div>
                                </div>
                            </form>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root >
        )
    }
}